<template>
  <a-modal :visible="visible" title="添加设备型号" :mask-closable="false" width="680px" @ok="handleOk" @cancel="handleCancel"
    ok-text="确认授权" cancel-text="取消" centered :ok-button-props="{ disabled: selectedModelIds.length === 0 }">
    <a-form :form="form" layout="vertical" :label-col="{ span: 10 }" :wrapper-col="{ span: 24 }">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="归属租户">
            <a-select v-model="params.tenantId" placeholder="请选择租户（已分配本客户端）" style="width: 100%" show-search allow-clear
              :filter-option="filterOption" @change="handleChangeTenant">
              <a-select-option v-for="item in tenantOptions" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="设备系列">
            <a-select v-model="params.seriesId" placeholder="全部系列" style="width: 100%" show-search allow-clear
              :filter-option="filterOption" @change="loadData()">
              <a-select-option v-for="item in seriesOptions" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="选择设备型号">
        <div class="model-list-area">
          <div class="list-title">
            <a-checkbox :checked="isAllSelected" :indeterminate="isIndeterminate" :disabled="allDisabled"
              @change="handleToggleAll">
              全选
            </a-checkbox>
          </div>

          <div class="series-group" v-for="group in seriesGroups" :key="group.groupCode">
            <div class="series-header">
              {{ group.groupName }}（{{ group.types.length }}）
            </div>
            <div class="series-body">
              <div class="model-item" v-for="m in group.types" :key="m.typeId"
                :class="{ 'model-item-disabled': !canSelect(m) }">
                <a-checkbox :checked="selectedModelIds.includes(m.typeId) || m.authorized" :disabled="!canSelect(m)"
                  @change="handleToggleOne(m)">
                  <div class="model-info">
                    <div class="model-name">{{ m.typeDescription }}</div>
                    <div class="model-sub">型号：{{ m.typeName }} · 设备 {{ m.deviceCount || 0 }} 台</div>
                  </div>
                </a-checkbox>
                <a-tag>{{ group.groupName }}</a-tag>
              </div>
            </div>
          </div>

          <a-empty v-if="seriesGroups.length === 0" description="暂无可选的设备型号" />
        </div>
      </a-form-item>
    </a-form>

    <div class="list-tip">
      勾选需要授权的设备型号，确认后该型号下全部设备自动获得本客户端使用资格。
    </div>
  </a-modal>
</template>

<script>
import { DEVICE_SERIES } from '../../clientConstants.js'

export default {
  name: 'AddModel',
  props: {
    visible: { type: Boolean, default: false },
    clientId: { type: String, default: '' },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      params: {
        id: this.clientId,
        tenantId: null,
        seriesId: null,
        keyword: null,
      },
      /* 租户选项（mock，后续从接口获取） */
      tenantOptions: [],
      /* 按系列分组的可选型号，从接口加载 */
      seriesGroups: [],
      /* 已选型号ID */
      selectedModelIds: [],
      /* 加载状态 */
      loading: false,
      seriesOptions: [],
      switchTenant: false,
    }
  },
  computed: {
    /* 是否全选 */
    flatModelIds() {
      const ids = []
      this.seriesGroups.forEach((g) => g.types.forEach((m) => !m.authorized && ids.push(m.typeId)))
      return ids
    },
    isAllSelected() {
      const ids = this.flatModelIds
      return ids.length > 0 && ids.every((id) => this.selectedModelIds.includes(id))
    },
    isIndeterminate() {
      const ids = this.flatModelIds
      const selected = ids.filter((id) => this.selectedModelIds.includes(id)).length
      return selected > 0 && selected < ids.length
    },
    allDisabled() {
      return this.seriesGroups.length === 0 || this.seriesGroups.every((g) => g.types.every((m) => !this.canSelect(m)))
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.selectedModelIds = []
        this.seriesGroups = []
        this.params.seriesId = undefined
        this.params.tenantId = undefined
        this.getClientTenantOptions()
      }
    },
  },
  methods: {
    handleChangeTenant() {
      this.seriesOptions = []
      // 增加标记
      this.switchTenant = true

      this.loadData()
    },
    async loadData() {
      this.loading = true
      this.selectedModelIds = []

      if (!this.params.tenantId) {
        this.seriesGroups = []
        return
      }

      try {
        const res = await this.$api.getAvailableModels(this.clientId, this.params)
        if (res && res.code == 0 && res.data) {
          if (Array.isArray(res.data)) {
            this.seriesGroups = res.data

            if (this.switchTenant) {
              // 利用 Map 的 key 唯一性进行去重和性能优化
              const optionsMap = new Map();

              res.data.forEach(g => {
                g.types?.forEach(m => {
                  if (!optionsMap.has(m.seriesId)) {
                    optionsMap.set(m.seriesId, { label: m.seriesName, value: m.seriesId });
                  }
                });
              });

              this.switchTenant = false
              this.seriesOptions.push(...optionsMap.values());
            }
          }
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async getClientTenantOptions() {
      try {
        const res = await this.$api.getClientTenantOptions(this.clientId)
        if (res && res.code == 0 && res.data) {
          if (Array.isArray(res.data)) {
            this.tenantOptions = res.data.map((i) => {
              return {
                value: i.tenantId,
                label: i.tenantName,
              }
            })
          }
        }
      } catch (e) {
        console.error(e)
      }
    },

    canSelect(model) {
      return !model.authorized
    },

    handleToggleAll(e) {
      const ids = this.flatModelIds
      if (e.target.checked) {
        ids.forEach((id) => {
          if (!this.selectedModelIds.includes(id)) this.selectedModelIds.push(id)
        })
      } else {
        this.selectedModelIds = this.selectedModelIds.filter((id) => !ids.includes(id))
      }
    },

    handleToggleOne(model) {
      const idx = this.selectedModelIds.indexOf(model.typeId)
      if (idx > -1) {
        this.selectedModelIds.splice(idx, 1)
      } else {
        this.selectedModelIds.push(model.typeId)
      }
    },

    handleOk() {
      if (this.selectedModelIds.length === 0) {
        this.$message.warning('请至少选择一个型号')
        return
      }
      this.$emit('confirm', { typeIds: this.selectedModelIds, tenantId: this.params.tenantId })
    },

    handleCancel() {
      this.$emit('close')
    },

    getSeriesLabel(value) {
      const t = DEVICE_SERIES.find((i) => i.value === value)
      return t ? t.label : value
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 6px;
}

.model-list-area {
  max-height: 360px;
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 12px;

  .list-title {
    font-size: 13px;
    color: #666;
    margin-bottom: 8px;
    padding: 0 0 8px 10px;
    border-bottom: 1px dashed #e8e8e8;
  }

  .series-group {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .series-header {
    font-size: 12px;
    font-weight: 500;
    color: #9ca3af;
    margin-bottom: 6px;
    padding-left: 10px;
  }

  .series-body {
    padding-left: 4px;
  }

  .model-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    border-radius: 10px;
    margin-bottom: 6px;
    transition: border-color .2s;

    &:hover {
      background: #e6f4ff;
    }

    &-disabled {
      opacity: .5;
      cursor: not-allowed;
    }

    .ant-checkbox-wrapper {
      display: flex;
      align-items: center;
    }

    .model-info {
      .model-name {
        font-size: 14px;
        color: #262626;
        font-weight: 500;
      }

      .model-sub {
        font-size: 12px;
        color: #9ca3af;
        margin-top: 2px;
      }
    }
  }
}

.list-tip {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}
</style>
